import { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppUserContext } from '../../App';
import { ErrorLoading } from '../../components/loading';
import ViewVehicles from './view-vehicles';

const Vehicles = () => {

    const { profile } = useContext(AppUserContext);

    if (profile.permission_level !== 1) {
        return <ErrorLoading>You do not have the permission to view/add/edit financial accounts.</ErrorLoading>
    }


    return (
        <Routes>
            <Route path="/:vehicleid/*" element={<ViewVehicles />} />
            <Route path="/" element={<ViewVehicles />} />
        </Routes>
    )
};

export default Vehicles;